import { getTextLinkModalOffset } from '@/util/pdf-annotator-util';
export default {
  data() {
    return {
      menuContainer: {
        show: false,
        left: 0,
        top: 0,
      },
      mainMenuShowed: false,
      tagModalShowed: false,
      taskModalShowed: false,
      colorModalShowed: false,
    };
  },
  methods: {
    hideContextualMenus() {
      this.menuContainer.show = false;
      this.mainMenuShowed = false;
      this.hideContextualSubmenus();
    },
    showContextualMenus(e) {
      this.menuContainer.show = true;
      this.mainMenuShowed = true;
      this.$nextTick(() => {
        this.menuContainer.left = e.x - getTextLinkModalOffset();
        this.menuContainer.top = e.y - 125;
      });
    },
    showTagModal() {
      this.hideContextualSubmenus();
      this.tagModalShowed = true;
    },
    hideTagModal() {
      this.tagModalShowed = false;
    },
    showTaskModal() {
      this.hideContextualSubmenus();
      this.taskModalShowed = true;
    },
    hideTaskModal() {
      this.taskModalShowed = false;
    },
    showColorModal() {
      this.hideContextualSubmenus();
      this.colorModalShowed = true;
    },
    hideColorModal() {
      this.colorModalShowed = false;
    },
    hideContextualSubmenus() {
      this.tagModalShowed = false;
      this.taskModalShowed = false;
      this.colorModalShowed = false;
    },
  },
};
